import script from "./RelatosList.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatosList.vue?vue&type=script&setup=true&lang=js"

import "./RelatosList.vue?vue&type=style&index=0&id=1519e3c1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1519e3c1"]])

export default __exports__